module.exports = __webpack_public_path__ + "static/media/t7.e382f441.jpg";